<template>
  <button
    type="button"
    class="group inline-flex size-11 shrink-0 cursor-pointer items-center justify-center rounded-full border-0 bg-transparent p-0 disabled:pointer-events-none disabled:cursor-default disabled:opacity-40"
  >
    <span
      class="flex size-11 items-center justify-center rounded-full border border-[#262626] bg-white text-[#262626] transition-colors group-hover:bg-code-medical-center-nav/5"
    >
      <svg class="size-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          :d="direction === 'prev' ? 'M15 19l-7-7 7-7' : 'M9 5l7 7-7 7'"
        />
      </svg>
    </span>
  </button>
</template>

<script setup>
defineProps({
  direction: {
    type: String,
    required: true,
    validator: (value) => value === 'prev' || value === 'next',
  },
})
</script>
